import { useEffect, useState } from "react";
import config  from "../config";

import sendData from "../common/sendData";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chats`;

function useDeleteChat(triggered, chatData) {
  const [statusCode, setStatusCode] = useState();
  const {keycloak} = useKeycloak();

  useEffect(() => {
    async function init() {
      if (!triggered) return

      let bearerToken = keycloak.token;
      let response = await sendData(bearerToken, ApiURL, "DELETE", chatData);
      
      setStatusCode(response);
    }

    init();
  // eslint-disable-next-line
  }, [triggered, chatData])

  return statusCode;
}

export default useDeleteChat;